import { render, staticRenderFns } from "./footer-justcr.vue?vue&type=template&id=104aebdc&scoped=true&"
import script from "./footer-justcr.vue?vue&type=script&lang=js&"
export * from "./footer-justcr.vue?vue&type=script&lang=js&"
import style0 from "./footer-justcr.vue?vue&type=style&index=0&id=104aebdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104aebdc",
  null
  
)

export default component.exports